<template>
    <div id="app-container" @click="closeMenu">
        <nav v-if="userName && !embedded" class="navbar navbar-vertical navbar-expand-lg navbar-light bg-light">
                <a class="navbar-brand" href="#">Configurator</a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#popup-nav-bar" aria-controls="popup-nav-bar" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
                </button>
                <div id="popup-nav-bar" ref="popup-nav-bar" class="collapse" v-if="userName && !embedded">
                    <ul class="nav flex-column">
                        <li class="nav-item">
                            <router-link class="nav-link" to="/">Home</router-link>
                        </li>
                        <div v-if="routes">
                            <li v-for="route in nonSetupRoutes" :key="route.Name" class="nav-item">
                                <router-link class="nav-link" :to="route.Route" :onclick="routeClicked">{{ route.Caption }}</router-link>
                            </li>   
                            <li v-for="route in setupRoutes" :key="route.Name" class="dropdown-item">
                                <router-link class="nav-link" :to="route.Route">{{ route.Caption }}</router-link>
                            </li>                     
                            <li class="nav-item">
                                <!--<router-link class="nav-link" to="/contact">Contact</router-link>-->
                            </li>

                            <li v-if="contact && contact.Organisation" class="nav-item"><a class="nav-link nav-menu-mobile" :href="contact.Organisation.URL">                                                        
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-link" viewBox="0 0 16 16">
                                    <path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9c-.086 0-.17.01-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z"/>
                                    <path d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4.02 4.02 0 0 1-.82 1H12a3 3 0 1 0 0-6H9z"/>
                                </svg>
                                Trust Portal</a></li>
                            <li v-if="tennant" class="nav-item"><a class="nav-link nav-menu-mobile" :href="'tel:'+tennant.Phone">                                
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
                                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
                                </svg>                                
                                {{ tennant.Phone }}</a></li>
                            <li v-if="tennant" class="nav-item"><a class="nav-link nav-menu-mobile" :href="'mailto:'+tennant.Email">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
                                </svg>
                                {{ tennant.Email }}</a>
                            </li>

                            <li class="nav-item">
                                <a class="nav-link" @click="logout">Log out {{ userName }}</a>
                            </li>
                        </div>
                    </ul>
                </div>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <div class="me-auto"></div>
                    <!--
                    <ul class="navbar-nav ml-auto" v-if="setupRoutes.length">
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false">Setup</a>
                            <ul class="dropdown-menu">
                                <li v-for="route in setupRoutes" :key="route.Name" class="dropdown-item">
                                    <router-link class="nav-link" :to="route.Route">{{ route.Caption }}</router-link>
                                </li>
                            </ul>
                        </li>   
                    </ul>-->
                    <form class="d-flex">
                        <ul class="navbar-nav ml-auto">
                            <li v-if="contact && contact.Organisation" class="nav-item"><a class="nav-link" :href="contact.Organisation.URL">                                                        
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-link" viewBox="0 0 16 16">
                                    <path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9c-.086 0-.17.01-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z"/>
                                    <path d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4.02 4.02 0 0 1-.82 1H12a3 3 0 1 0 0-6H9z"/>
                                </svg>
                                Trust Portal</a></li>
                            <li v-if="tennant" class="nav-item"><a class="nav-link" :href="'tel:'+tennant.Phone">                                
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
                                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
                                </svg>                                
                                {{ tennant.Phone }}</a></li>
                            <li v-if="tennant" class="nav-item"><a class="nav-link" :href="'mailto:'+tennant.Email">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
                                </svg>
                                {{ tennant.Email }}</a></li>
                        </ul>
                        <button class="btn btn-logout" @click="logout">Log out {{ userName }}</button>                 
                    </form>
                </div>
        </nav>
        <div >
            <div id="lh-nav-bar" class="navbar-expand" v-if="userName && !embedded">
                <ul class="nav flex-column">
                    <li class="nav-item">
                        <router-link class="nav-link" to="/">Home</router-link>
                    </li>
                    <div v-if="routes">
                        <li v-for="route in nonSetupRoutes" :key="route.Name" class="nav-item">
                            <router-link class="nav-link" :to="route.Route" :onclick="routeClicked">{{ route.Caption }}</router-link>
                        </li>   
                        <li v-for="route in setupRoutes" :key="route.Name" class="dropdown-item">
                            <router-link class="nav-link" :to="route.Route">{{ route.Caption }}</router-link>
                        </li>                     
                        <li class="nav-item">
                            <!--<router-link class="nav-link" to="/contact">Contact</router-link>-->
                        </li>
                        <li class="nav-item">
                            <a class="nav-link nav-menu-mobile" href="#" @click="logout">Log out {{ userName }}</a>
                        </li>
                    </div>
                </ul>
            </div>
            <div id="subpage-view">
                <router-view @logged-in="onLoggedIn"></router-view>
            </div>
        </div>            

  </div>
</template>

<script>
export default {
    name: 'App',
    emits: ['routeClicked'],  
    components: {
    },
    data() {
            return {   
              userName: null,
              apiKey: '',
              embedded: false,
              routes: [],
              tennant: {},
              contact: {}
            }      
    },
    computed: {
        getTime: function() {
            console.log('called');
            return new Date().getTime();
        },
        setupRoutes: function() {
            return this.routes ? this.routes.filter(r => r.IsSetup && r.ShowLink) : [];
        },
        nonSetupRoutes: function() {
            return this.routes ? this.routes.filter(r => !r.IsSetup && r.ShowLink) : [];
        }
    },
    created: function () {
        this.init();
    },  
    methods: {           
            logout() {
                console.log('Logging out');
                localStorage.clear();
                this.$router.replace('/login');
                window.location.reload();
            }, 
            closeMenu() {
                var navbar = this.$refs['popup-nav-bar'];
                if(navbar) {
                    navbar.classList.remove('show');
                }
            },  
            onLoggedIn() {
                this.init();
            },
            routeClicked() {
               //console.log(this.$router.App);

               //this.$router.App._instance.update();
               //console.log(this.$router.routeClicked);

               dispatchEvent(this.$router.routeClicked);
               //dispatchEvent(routeClicked);
            },
            init() { 

                //localStorage.clear();             
                this.embedded = localStorage.getItem('embedded');  
                this.userName = localStorage.getItem('userName');
                 
                var css = this.getSetting('StyleSheet');
                if(css) {
                    this.addStyleSheet(css);
                }

                this.routes = JSON.parse(localStorage.getItem('permissions'));  

                //console.log(this.routes);

                if(this.routes) {
                    this.routes.forEach(route => { 

                        //if(route.showLink) {
                            var component = () => import('' + route.Component);                       
                            this.$router.addRoute(
                                { name: route.Caption, path: route.Route, component: component });                        
                        //}
                    });
                } 
                
                //console.log(this.$router.getRoutes());
                var _this = this;

                this.tennantId = localStorage.getItem('tennantId');
                if(this.tennantId) {
                    var url = this.apiUrl + 'tennants/' + this.tennantId + '/contact';
                    this.get(url,function(data) {

                        //console.log(data);

                        _this.tennant = data;
                        _this.setQuoteAcceptedText(data.quotationAcceptedText);
                    });
                }

                this.contactId = localStorage.getItem('contactId');
                if(this.contactId && this.contactId > 0) {
                    url = this.apiUrl + 'contacts/' + this.contactId;
                    this.get(url,function(data) {
                        if(data) {
                            //console.log(data);

                            _this.contact = data;
                            if(data.AcceptedQuoteId)
                                _this.setAcceptedQuoteId(data.AcceptedQuoteId);                    
                        }
                    });
                }
            }       
        },
}
</script>

<style>    
#subpage-view {
    padding: 10px;
}
div#lh-nav-bar,div#subpage-view {
    /*max-width: 80%;*/
    float: left;
}
a.navbar-brand {
    padding-left: 18px;
}
button.btn-logout {
    margin-right: 10px;
}

@media (min-width: 992px) {
    a.nav-menu-mobile {
       visibility: hidden;
    } 
    div#popup-nav-bar {
        display: none;
    }
}

@media (max-width: 992px) {
    div#app-container {
        min-width:100%;
    }
    a.nav-menu-mobile {
        visibility: visible;
    } 
    a.navbar-brand {
        /*display: none;*/
        width:70px;
        position: absolute;
        background-position-x: 20px;
        left: calc(100% - 121px);
        background-repeat: no-repeat;
        background-size: 50% 50%;
    }
    div#lh-nav-bar {
        display: none;
    }
    div#subpage-view {
        left: 0px!important;
    }
    .navbar-toggler {
        position: absolute;
        top:0px;
        z-index: 500;
    }
    div#popup-nav-bar {
        position: absolute;
        top: 30px;
        left: 0px;
        z-index: 500;
        background: white;
    }
    #subpage-view {
        padding: 0px;
        max-width: 100%;
    }
}

</style>
